import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import React, { CSSProperties } from 'react'
import { ArIcon } from 'src/shared/icons/languages/ar-icon'
import { CsIcon } from 'src/shared/icons/languages/cs-icon'
import { DeIcon } from 'src/shared/icons/languages/de-icon'
import { DkIcon } from 'src/shared/icons/languages/dk-icon'
import { ElIcon } from 'src/shared/icons/languages/el-icon'
import { EnIcon } from 'src/shared/icons/languages/en-icon'
import { EsIcon } from 'src/shared/icons/languages/es-icon'
import { FrIcon } from 'src/shared/icons/languages/fr-icon'
import { HiIcon } from 'src/shared/icons/languages/hi-icon'
import { HuIcon } from 'src/shared/icons/languages/hu-icon'
import { IdIcon } from 'src/shared/icons/languages/id-icon'
import { ItIcon } from 'src/shared/icons/languages/it-icon'
import { JpIcon } from 'src/shared/icons/languages/jp-icon'
import { NlIcon } from 'src/shared/icons/languages/nl-icon'
import { NoIcon } from 'src/shared/icons/languages/no-icon'
import { PlIcon } from 'src/shared/icons/languages/pl-icon'
import { PtIcon } from 'src/shared/icons/languages/pt-icon'
import { RoIcon } from 'src/shared/icons/languages/ro-icon'
import { RuIcon } from 'src/shared/icons/languages/ru-icon'
import { SkIcon } from 'src/shared/icons/languages/sk-icon'
import { SlIcon } from 'src/shared/icons/languages/sl-icon'
import { SqIcon } from 'src/shared/icons/languages/sq-icon'
import { SrIcon } from 'src/shared/icons/languages/sr-icon'
import { SvIcon } from 'src/shared/icons/languages/sv-icon'
import { ThIcon } from 'src/shared/icons/languages/th-icon'
import { TrIcon } from 'src/shared/icons/languages/tr-icon'
import { UaIcon } from 'src/shared/icons/languages/ua-icon'
import { ZhIcon } from 'src/shared/icons/languages/zh-icon'

interface WebsiteLanguageSwitcherIconProps {
  locale: PageLocaleEnum
  className?: string
  style?: CSSProperties
}
export const WebsiteLanguageSwitcherIcon = ({
  locale,
  className,
  style,
}: WebsiteLanguageSwitcherIconProps) => {
  switch (locale) {
    case PageLocaleEnum.ENGLISH:
      return <EnIcon className={className} style={style} />
    case PageLocaleEnum.FRENCH:
      return <FrIcon className={className} style={style} />
    case PageLocaleEnum.SPANISH:
      return <EsIcon className={className} style={style} />
    case PageLocaleEnum.ITALIAN:
      return <ItIcon className={className} style={style} />
    case PageLocaleEnum.PORTUGUESE:
      return <PtIcon className={className} style={style} />
    case PageLocaleEnum.DEUTSCH:
      return <DeIcon className={className} style={style} />
    case PageLocaleEnum.DUTCH:
      return <NlIcon className={className} style={style} />
    case PageLocaleEnum.RUSSIAN:
      return <RuIcon className={className} style={style} />
    case PageLocaleEnum.JAPANESE:
      return <JpIcon className={className} style={style} />
    case PageLocaleEnum.ARABIC:
      return <ArIcon className={className} style={style} />
    case PageLocaleEnum.TURKISH:
      return <TrIcon className={className} style={style} />
    case PageLocaleEnum.CHINESE:
      return <ZhIcon className={className} style={style} />
    case PageLocaleEnum.SWEDISH:
      return <SvIcon className={className} style={style} />
    case PageLocaleEnum.ROMANIAN:
      return <RoIcon className={className} style={style} />
    case PageLocaleEnum.CZECH:
      return <CsIcon className={className} style={style} />
    case PageLocaleEnum.HUNGARIAN:
      return <HuIcon className={className} style={style} />
    case PageLocaleEnum.SLOVAK:
      return <SkIcon className={className} style={style} />
    case PageLocaleEnum.DANISH:
      return <DkIcon className={className} style={style} />
    case PageLocaleEnum.INDONESIAN:
      return <IdIcon className={className} style={style} />
    case PageLocaleEnum.POLISH:
      return <PlIcon className={className} style={style} />
    case PageLocaleEnum.GREEK:
      return <ElIcon className={className} style={style} />
    case PageLocaleEnum.SERBIAN:
      return <SrIcon className={className} style={style} />
    case PageLocaleEnum.HINDI:
      return <HiIcon className={className} style={style} />
    case PageLocaleEnum.NORWEGIAN:
      return <NoIcon className={className} style={style} />
    case PageLocaleEnum.THAI:
      return <ThIcon className={className} style={style} />
    case PageLocaleEnum.SLOVENIAN:
      return <SlIcon className={className} style={style} />
    case PageLocaleEnum.UKRAINIAN:
      return <UaIcon className={className} style={style} />
    case PageLocaleEnum.ALBANIA:
      return <SqIcon className={className} style={style} />
    default:
      break
  }
}
